import React, { useState } from 'react';

// helpers
import styled from 'styled-components';
import useTranslation from 'hooks/useTranslation';
import { Moment } from 'moment';
import { ShortDocumentModel } from 'typings/documents/documents';
import { wireTransferValidationSchema } from 'validations/accounting/transfers';
import {
  TransferSenderModel,
  WireTransferRecipientModel,
} from 'typings/accounting/transfer';

// components
import InnerForm from './InnerForm';
import SubmitButton from '../../../../Buttons/SubmitButton';
import PreviewApprovalWorkflowModalDialog from './PreviewApprovalWorkflowModalDialog';
import { Form, RequiredPropsForFormModel, Col, Row } from '@ui';

export interface FormValuesModel {
  valueDate: Moment;
  amount: number | null;
  transactionPurpose: string;
  sender: TransferSenderModel;
  documents: ShortDocumentModel[];
  transactionCurrencyId: number | null;
  recipient: WireTransferRecipientModel;
}

interface IProps extends RequiredPropsForFormModel<FormValuesModel> {
  emptyTransactionFormValues: FormValuesModel;
}

const SubmitButtonGridSizes = { xl: 4, lg: 6, md: 8, sm: 24, xs: 24 };

const WireTransferForm = ({
  initialValues,
  onSubmit,
  disabled,
  emptyTransactionFormValues,
}: IProps) => {
  const { t } = useTranslation('common');

  const [isPreviewApprovalVisible, setIsPreviewApprovalVisible] =
    useState(false);

  const handleSubmit = () => {
    setIsPreviewApprovalVisible(true);
  };

  return (
    <Form<FormValuesModel>
      validationSchema={wireTransferValidationSchema}
      onSubmit={handleSubmit}
      initialValues={initialValues}
      confirmExitWithoutSaving
      disabled={disabled}
      renderForm={
        <>
          <InnerForm />
          <Row justify="end">
            <Col {...SubmitButtonGridSizes}>
              <StyledSubmitButton type="primary">
                {t('submit', { ns: 'common' })}
              </StyledSubmitButton>
            </Col>
          </Row>
          <PreviewApprovalWorkflowModalDialog
            onSubmit={onSubmit}
            emptyTransactionFormValues={emptyTransactionFormValues}
            isVisible={isPreviewApprovalVisible}
            closeCallback={() => setIsPreviewApprovalVisible(false)}
          />
        </>
      }
    />
  );
};

const StyledSubmitButton = styled(SubmitButton)`
  width: 100%;
  padding: 0px;
  min-width: 0px;
`;

export default WireTransferForm;
